import { render, staticRenderFns } from "./TeacherHome.vue?vue&type=template&id=75bae700&scoped=true"
import script from "./TeacherHome.vue?vue&type=script&lang=js"
export * from "./TeacherHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bae700",
  null
  
)

export default component.exports